import { useEffect, useState } from "react";
import type { InputDateProps } from "./inputDateType";

export function useInputDate({ value, onChange, locale }: InputDateProps) {
  const [internalValue, setInternalValue] = useState<Date | undefined>(value);

  useEffect(() => {
    setInternalValue(value);

    // se limpou o valor externo, limpa o input visível também
    if (!value) {
      setRawValue("");
    }
  }, [value]);

  const dateFormatter = new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const handleChange = (date: Date) => {
    setInternalValue(date);
    onChange?.(date);
  };

  const [rawValue, setRawValue] = useState("");

  /** Mascara DD/MM/AAAA */
  const handleManualInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    let v = e.target.value.replace(/\D/g, "").slice(0, 8);

    if (v.length >= 5) v = v.replace(/(\d{2})(\d{2})(\d{1,4})/, "$1/$2/$3");
    else if (v.length >= 3) v = v.replace(/(\d{2})(\d{1,2})/, "$1/$2");

    setRawValue(v);

    // Quando completar a data, converte para Date corretamente
    if (v.length === 10) {
      const [dd, mm, yyyy] = v.split("/").map(Number);
      const date = new Date(yyyy, mm - 1, dd);

      if (!isNaN(date.getTime())) {
        handleChange(date);
      }
    }
  };

  return {
    internalValue,
    setInternalValue,
    dateFormatter,
    handleChange,
    handleManualInput,
    rawValue,
    setRawValue,
  };
}
